import {bindEvent, runNewScripts} from "../utils/functions";

export class FramePage {
    constructor(wrapper) {
        let that = this
        this.history = Array()
        this.wrapper = wrapper
        let css = {
            card: "card",
            cardHeader: "card-header p-4",
            cardHeaderText: "title mb-0 is-4",
            cardHeaderMenuButton: "",
        }
        if (wrapper.dataset.isSmall === 'true') {
            css = {
                card: "",
                cardHeader: "",
                cardHeaderText: "title mb-0 is-6",
                cardHeaderMenuButton: "is-small",
            }
        }
        this.wrapper.innerHTML = `
        <div class="fp-card ${css.card}">
            <div class="fp-card-header ${css.cardHeader} is-flex is-justify-content-space-between">
                <div class="fp-card-header-text ${css.cardHeaderText}">
                    ${wrapper.dataset.title || ''}
                    
                    <sup class="${wrapper.dataset.helpTooltip ? '' : 'is-hidden'}" 
                        style="cursor: help" title="${wrapper.dataset.helpTooltip}">
                        <i class="fa fa-info-circle"></i>
                    </sup>
                </div>
                <div class="menu nowrap ml-3">                    
                    <button class="button btn-back ${css.cardHeaderMenuButton} is-hidden" type="button" title="Back">
                        <span class="icon"><i class="fa fa-arrow-left"></i></span>
                    </button>
                    <button class="button btn-back-to-first ${css.cardHeaderMenuButton} is-hidden" type="button" title="Back to the first page">
                        <span class="icon"><i class="fa fa-refresh"></i></span>
                    </button>
                    <a href="#" class="button btn-link ${css.cardHeaderMenuButton} ${wrapper.dataset.allowLinkButton === 'true' ? '' : 'is-hidden'}" role="button" title="Link to page">
                        <span class="icon"><i class="fa fa-link"></i></span>
                    </a>
                    <button class="button btn-fullscreen ${css.cardHeaderMenuButton} ${wrapper.dataset.allowFullscreen === 'true' ? '' : 'is-hidden'}" type="button" title="Fullscreen preview">
                        <span class="icon"><i class="fa fa-expand"></i></span>
                    </button>
                    <button class="button btn-fullscreen is-hidden ${css.cardHeaderMenuButton}" type="button" title="Close fullscreen">
                        <span class="icon"><i class="fa fa-x"></i></span>
                    </button>
                    <button class="button btn-show-hide ${css.cardHeaderMenuButton}" type="button" title="Show / Hide">
                        <span class="icon"><i class="fa fa-eye"></i></span>
                    </button>
                </div>
            </div>
        </div>
        `;
        this.card = wrapper.querySelector(".fp-card")
        this.menu = this.card.querySelector(".menu")
        this.btnBack = wrapper.querySelector(".btn-back")
        this.btnBackToFirst = wrapper.querySelector(".btn-back-to-first")
        this.container = document.createElement("div")
        this.container.classList.add("card-content");
        if (wrapper.dataset.minimized) {
            this.container.classList.add("is-hidden");
        }
        this.container.style.overflow = "auto";
        this.card.appendChild(this.container)
        this.skeleton = document.createElement("div")
        this.skeleton.classList.add("skeleton", "has-text-centered", "py-4", "is-block")
        this.skeleton.innerHTML = "<img src='/static/imgs/loading.svg' alt='loading...' style='height: 300px' /> <p class='mt-3 title is-4'>Loading...</p>"
        this.container.appendChild(this.skeleton)
        this.container.addEventListener('click', function (e) {
            const link = e.target.closest('a')
            if (link && (link.target === "_blank" || e.ctrlKey || e.shiftKey)) {
                return
            }
            if (link && !link.getAttribute('href').startsWith("#") && this.contains(link)) {
                e.preventDefault()
                let url = link.getAttribute('href') ?? null;
                if (url === null) return;
                if (url[0] === "?") {
                    url = `${that.url.split("?")[0]}${url}`
                }
                that.loadPage(url)
            }
        })
        // bindEvent(this.container, "submit", "form", true, async e => {
        //     e.preventDefault()
        //     const formData = new FormData(this)
        //     try {
        //         const response = await fetch(this.action, {
        //             method: this.method,
        //             body: formData,
        //             redirect: 'follow' // nebo 'manual' pokud chceš řídit sám
        //         });
        //
        //         if (response.redirected) {
        //             console.log("RRR", response)
        //             return;
        //         }
        //
        //         console.log(response)
        //
        //         const result = await response.json(); // nebo .text(), .blob(), podle typu
        //
        //         console.log('Odpověď serveru:', result);
        //     } catch (err) {
        //         console.error('Chyba při odesílání formuláře:', err);
        //     }
        // })
        this.container.addEventListener("location_changed", e => {
            e.preventDefault()
            let url = e.detail
            if (url[0] === "?")
                url = `${that.url.split("?")[0]}${url}`
            that.loadPage(url)
        })
        bindEvent(this.menu, "click", ".btn-back", true, e => {
            that.history.pop()
            that.loadPage(that.history.pop())
        })
        bindEvent(this.menu, "click", ".btn-back-to-first", true, e => {
            that.history = Array()
            that.loadPage(that.wrapper.dataset.url)
        })
        bindEvent(this.menu, "click", ".btn-fullscreen", true, e => {
            that.card.classList.toggle("fp-fullscreen")
            e.target.closest(".fp-card-header").querySelectorAll(".btn-fullscreen").forEach(b => {b.classList.toggle("is-hidden")})
            e.target.closest("div").querySelector(".btn-show-hide").classList.toggle("is-hidden")
            that.container.classList.remove("is-hidden")
        })
/*        bindEvent(this.menu, "mousedown", ".btn-link", true, e => {
            e.target.closest(".btn-link").href = that.url.replace(/__modal(=[tT]rue)?&?/g, '').replace(/__no_name(=[tT]rue)?&?/g, '').replace(/list.columns=[^&]*!/g, '');
        })*/
        bindEvent(this.menu, "click", ".btn-show-hide", true, e => {
            that.container.classList.toggle("is-hidden")
        })

        this.loadPage(this.wrapper.dataset.url)
    }

    addModalParam(urlStr) {
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(urlStr)) {
            return urlStr
        }

        const base = 'http://dummy.base'; // pomocná základna pro relativní URL
        let url;

        try {
            url = new URL(urlStr, base); // zpracuje i relativní URL
        } catch (e) {
            console.error('Invalid URL input:', urlStr);
            return urlStr;
        }

        const params = url.searchParams;

        if (!params.has('__modal')) {
            params.set('__modal', 'True');
            url.search = params.toString();
        }

        return url.pathname + url.search + url.hash;
    }

    loadPage(url) {
        this.wrapper.querySelector(".btn-link").href = url.replace(/__modal(=[tT]rue)?&?/g, '').replace(/__no_name(=[tT]rue)?&?/g, '').replace(/list.columns=[^&]*/g, '');
        this.container.innerHTML = ""
        this.container.appendChild(this.skeleton)
        url = this.addModalParam(url)
        this.history.push(url)
        if (this.history.length < 2) {
            this.btnBack.classList.add("is-hidden")
            this.btnBackToFirst.classList.add("is-hidden")
        } else {
            this.btnBack.classList.remove("is-hidden")
            this.btnBackToFirst.classList.remove("is-hidden")
        }
        this.url = url
        axios.get(url)
            .then(response => {
                const contentType = response.headers['content-type'] || '';
                if (contentType.startsWith('image/')) {
                    this.container.innerHTML = `<img src="${url}" alt="${url}" style="display: block; margin: auto;" />`;
                } else {
                    this.container.innerHTML = response.data
                    runNewScripts(this.container)
                }
            })
            .catch(err => {
                console.warn(err)
                let img = "burning-server.png"
                let msg = err.response?.data?.message || err.message
                if (err.response && err.response.status === 404) {
                    img = "not-found.png"
                    msg = "Page not found"
                } else if (err.response && (err.response.status === 403 || err.response.status === 401)) {
                    img = "locked_aquarium.png"
                    msg = "Access denied"
                }
                this.container.innerHTML = `
<div class="has-text-centered">
    <img src="/static/imgs/${img}" alt="${msg}" style="max-height: 300px;" />
    <p class="mt-3 mb-4 title is-4">${msg}</p>
</div>
`
            })
    }
}